import UserApi from '../data/api/user-api';

class UserRepository {
  constructor(firebaseConfig, state) {
    this.api = new UserApi(firebaseConfig, state);
  }

  getAll() {
    return this.api.getAll();
  }

  getByUsername(username) {
    return this.api.getByUsername(username);
  }

  setupUser(userId, initialUserData) {
    return this.api.setupUser(userId, initialUserData);
  }
}

export default UserRepository;
